import React, { useState, useEffect } from 'react';
import { useNavigate, Routes, Route, NavLink } from 'react-router-dom';
import AdminSummary from './AdminSummary';
import AdminSkills from './AdminSkills';
import AdminExperience from './AdminExperience';
import AdminProjects from './AdminProjects';
import AdminEducation from './AdminEducation';
import AdminProfilePicture from './AdminProfilePicture';

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/admin/login');
    } else {
      setAuthenticated(true);
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/admin/login');
  };

  if (!authenticated) {
    return null;
  }

  const navLinkStyle = (isActive) => ({
    padding: '0.75rem 1.5rem',
    border: '2px solid #667eea',
    background: isActive 
      ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' 
      : 'white',
    color: isActive ? 'white' : '#667eea',
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: '600',
    textDecoration: 'none',
    transition: 'all 0.3s ease',
  });

  const navLinkStyleDark = (isActive) => ({
    padding: '0.75rem 1.5rem',
    border: '2px solid #7c3aed',
    background: isActive 
      ? 'linear-gradient(135deg, #7c3aed 0%, #9333ea 100%)' 
      : '#334155',
    color: isActive ? 'white' : '#cbd5e1',
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: '600',
    textDecoration: 'none',
    transition: 'all 0.3s ease',
  });

  return (
    <div className="admin-container dark:bg-gradient-to-br dark:from-slate-900 dark:to-slate-800">
      <div className="admin-dashboard dark:bg-slate-800">
        <div className="admin-header dark:border-slate-600">
          <h1 className="dark:text-gray-200">Admin Dashboard</h1>
          <button 
            className="btn btn-secondary dark:bg-slate-600 dark:hover:bg-slate-500 dark:text-gray-200" 
            onClick={handleLogout}
          >
            Logout
          </button>
        </div>

        <nav className="admin-nav">
          <NavLink
            to="/admin"
            end
            style={({ isActive }) => {
              const isDark = document.documentElement.classList.contains('dark');
              return isDark ? navLinkStyleDark(isActive) : navLinkStyle(isActive);
            }}
          >
            Summary
          </NavLink>
          <NavLink
            to="/admin/skills"
            style={({ isActive }) => {
              const isDark = document.documentElement.classList.contains('dark');
              return isDark ? navLinkStyleDark(isActive) : navLinkStyle(isActive);
            }}
          >
            Skills
          </NavLink>
          <NavLink
            to="/admin/experience"
            style={({ isActive }) => {
              const isDark = document.documentElement.classList.contains('dark');
              return isDark ? navLinkStyleDark(isActive) : navLinkStyle(isActive);
            }}
          >
            Experience
          </NavLink>
          <NavLink
            to="/admin/projects"
            style={({ isActive }) => {
              const isDark = document.documentElement.classList.contains('dark');
              return isDark ? navLinkStyleDark(isActive) : navLinkStyle(isActive);
            }}
          >
            Projects
          </NavLink>
          <NavLink
            to="/admin/education"
            style={({ isActive }) => {
              const isDark = document.documentElement.classList.contains('dark');
              return isDark ? navLinkStyleDark(isActive) : navLinkStyle(isActive);
            }}
          >
            Education
          </NavLink>
          <NavLink
            to="/admin/profile-picture"
            style={({ isActive }) => {
              const isDark = document.documentElement.classList.contains('dark');
              return isDark ? navLinkStyleDark(isActive) : navLinkStyle(isActive);
            }}
          >
            Profile Picture
          </NavLink>
        </nav>

        <div className="admin-content dark:bg-slate-700">
          <Routes>
            <Route path="/" element={<AdminSummary />} />
            <Route path="/skills" element={<AdminSkills />} />
            <Route path="/experience" element={<AdminExperience />} />
            <Route path="/projects" element={<AdminProjects />} />
            <Route path="/education" element={<AdminEducation />} />
            <Route path="/profile-picture" element={<AdminProfilePicture />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
